// extracted by mini-css-extract-plugin
export var closeButton = "_n5-2";
export var closeButtonIcon = "_n5-3";
export var lightboxContent = "_n5-1";
export var lightboxOverlay = "_n5-0";